








import { Component, Vue, Watch } from "vue-property-decorator";
import { RouteConfig } from "vue-router";
import Routes from "@/Routes";

@Component({
  components: {}
})
export default class PassengerPageRoot extends Vue {
  get routeName() {
    return this.$route.name;
  }

  get routePassengerId(): string {
    return this.$store.state.route.params.passengerId;
  }

  get navigationRoutes(): any[] {
    const passengerRoot = (this.$router as any).options.routes.find(
      (r: any) => r.meta && r.meta.passengerRoot
    ) as RouteConfig;

    if (!passengerRoot) {
      return [];
    }
    const navRoutes = passengerRoot.children.map(c => c).filter(r => r.meta.passengerNav);
    return navRoutes;
  }

  async redirectToFirstNavigationRoute(alreadyRedirected: boolean = false) {
    try {
      if (this.$route.name === Routes.passengerRoute.name) {
        if (this.routePassengerId) {
          this.$router.replace({
            name: Routes.editPassengerRoute.name,
          });
        } 
      }
    } catch (err) {
      if (this.routePassengerId && !alreadyRedirected) {
        await this.$router.replace({
          name: Routes.passengerRoute.name,
        });

        await this.redirectToFirstNavigationRoute(true);
      } else {
        throw err;
      }
    }
  }

  created() {
    this.redirectToFirstNavigationRoute();
  }

  @Watch("routeName", { immediate: false })
  onRouteNameChanged(val, newVal) {
    this.redirectToFirstNavigationRoute();
  }
}
